import { useNavigate } from "react-router-dom";
import { t } from "ttag";

import type { Subscription } from "@/features/billing/models";
import { useUpdateFollowUpStatus } from "@/features/forms/hooks";
import { FORMS_ROUTE } from "@/features/forms/router/constants";
import type { Product } from "@/features/products/models";
import { Banner, Button, HeartIcon } from "@/shared/ui";

interface CheckInBannerProps {
  productId: Product["id"];
  subscriptionId: Subscription["id"];
}

export const CheckInBanner = ({
  productId,
  subscriptionId,
}: CheckInBannerProps) => {
  const navigate = useNavigate();

  const updateMutation = useUpdateFollowUpStatus();

  const handleClick = () => {
    updateMutation.mutate(subscriptionId);
  };

  const disabled = updateMutation.isPending;

  return (
    <Banner.Root>
      <Banner.Header>
        <Banner.Label className="inline-flex items-center gap-1">
          <HeartIcon className="size-4" />
          {t`Check-in`}
        </Banner.Label>

        <Banner.Title>
          {t`How is Microdosing working out for you?`}
        </Banner.Title>
      </Banner.Header>

      <Banner.Content>
        <Banner.Description>
          {t`We hope everything is going smoothly! If you've had any issues, please
      complete the intake form so we can better support you.`}
        </Banner.Description>
      </Banner.Content>

      <Banner.Actions>
        <Button
          variant="secondary"
          size="lg"
          onClick={() => {
            navigate(`${FORMS_ROUTE.CHECK_IN}/${productId}`);
          }}
        >
          {t`Go to form`}
        </Button>

        <Button size="lg" onClick={handleClick}>
          {t`All good`}
        </Button>
      </Banner.Actions>

      {disabled && (
        <div className="absolute top-0 left-0 size-full cursor-wait" />
      )}
    </Banner.Root>
  );
};
